<template>
<div class="flex justify-center items-center flex-col" style="height:85vh;overflow:auto;">
    <div class="menu ">

        <router-link to="/card_topup">
        <div class="active:bg-menu1 menu1 h-64  w-36 float-left ml-4 mt-4 flex flex-col justify-center items-center cursor-pointer rounded"  >
           <p class="menuLogo">
                <i class="iconfont icon-fuhao"></i>
           </p>
           <p>充值</p>
        </div>
        </router-link>

        <div class="float-left ">
         <router-link to="/card_consume">
        <div class="active:bg-menu2 menu2   w-36  ml-4 mt-4 flex justify-center items-center  cursor-pointer rounded" style="height:7.5rem;" >
               <p class="menuLogo">
            <i class="iconfont icon-qiandai"></i>
            </p>
            <p>消费</p>
        </div>
        </router-link>
         <router-link to="/pick_up">
        <div class="active:bg-menu3 menu3  w-36 mt-4 ml-4 flex justify-center items-center  cursor-pointer rounded" style="height:7.5rem;">
              <p class="menuLogo">
             <i class="iconfont icon-youhuiquan"></i>
             </p>
            <p>核销</p>
        </div>
        </router-link>
        </div>

        <router-link to="/card_sale">
         <div class="active:bg-menu4 menu4 h-64  w-36 float-left mt-4 ml-4 flex flex-col justify-center items-center  cursor-pointer rounded"  >
           <p class="menuLogo">
           <i class="iconfont icon-huiyuanqiagoumai" ></i>
           </p>
           <p>售卡</p>
        </div>
        </router-link>

         <router-link to="/search">
        <div class="active:bg-menu5 menu5 h-64  w-36 float-left ml-4 mt-4 flex flex-col justify-center items-center  cursor-pointer rounded" >
             <p class="menuLogo">
            <i class="iconfont icon-chaxun"></i>
            </p>
           <p>查询</p>
        </div>
        </router-link>

        <router-link to="/record">
        <div class="active:bg-menu7 menu7   float-left ml-4 mt-4 flex  justify-center items-center  cursor-pointer rounded clear-left"  style="height:7rem;width:19rem;">
    <p class="menuLogo">
            <i class="iconfont icon-jiaoyijilu"></i>
            </p>
           <p>交易记录</p>
        </div>
        </router-link>

        <router-link to="/coupon_topup">
        <div class="active:bg-menu6 menu6  w-36 float-left ml-4 mt-4 flex  justify-center items-center  cursor-pointer rounded "  style="height:7rem;">
           <p class="menuLogo">
            <i class="iconfont icon-tianmaohaoquan"></i>
            </p>
           <p>充次</p>
        </div>
        </router-link>

        <router-link to="/report">
        <div class="active:bg-menu8 menu8  w-36 float-left ml-4 mt-4 flex  justify-center items-center  cursor-pointer rounded"  style="height:7rem;">
    <p class="menuLogo">
            <i class="iconfont icon-baobiao"></i>
            </p>
           <p>报表</p>
        </div>
        </router-link>

    </div><!--left-->
    
    <div>
        <router-link to="/order_pickup">
        <div class="active:bg-menu3 menu3  w-36 float-left  mt-4 flex  justify-center items-center  cursor-pointer rounded"  style="height:5rem;">
    <p class="menuLogo">
            <i class="iconfont icon-jiaoyijilu"></i>
            </p>
           <p>提货</p>
        </div>
        </router-link>


    </div>



</div>
</template>
<script>
export default {

}
</script>
<style scoped>
.menuLogo .iconfont{
    font-size:25pt;
}
.menu1{
    background-color: #00CC76;
    color:#FFFFFF;
    font-size:1.5rem;
}
.menu2{
    background-color: #00C3BA;
    color:#FFFFFF;
    font-size:1.5rem;
}
.menu3{
    background-color: #FFAE47;
    color:#FFFFFF;
    font-size:1.5rem;
}
.menu4{
    background-color: #0082E9;
    color:#FFFFFF;
    font-size:1.5rem;
}
.menu5{
    background-color: #5F9EA0;
    color:#FFFFFF;
    font-size:1.5rem;
}

.menu6{
    background-color: #7986CA;
    color:#FFFFFF;
    font-size:1.5rem;
}
.menu7{
    background-color: #AFD7F7;
    color:#FFFFFF;
    font-size:1.5rem;
}

.menu8{
    background-color: #C8B4E1;
    color:#FFFFFF;
    font-size:1.5rem;
}

.active\:bg-menu1:active {
 background-color: #038f54;

}
.active\:bg-menu2:active {
 background-color: #028680;

}
.active\:bg-menu3:active {
 background-color: #864d01;

}
.active\:bg-menu4:active {
 background-color: #014780;

}
.active\:bg-menu5:active {
 background-color: #05878b;

}
.active\:bg-menu6:active {
 background-color: #2542ce;

}
.active\:bg-menu7:active {
 background-color: #0a4c81;

}
.active\:bg-menu8:active {
 background-color: #8333e6;

}

</style>
